import type { OnboardingTemplateOption } from '@/hooks/employees/useOnboardingTemplates';

/**
 * Which onboarding workflow the Add employee form preselects:
 * - a hire (`defaultTaskListId` given): the Hired stage's template while it
 *   is still one of the active templates; none when the stage has none;
 * - the Employees page (`defaultTaskListId` undefined): the company's only
 *   template when it has exactly one; none with two or more, since picking
 *   one for the user would be a guess.
 */
export const defaultOnboardingWorkflow = (
  templates: OnboardingTemplateOption[],
  defaultTaskListId: string | null | undefined
): string | undefined => {
  if (defaultTaskListId === undefined) {
    return templates.length === 1 ? templates[0].id : undefined;
  }
  return templates.find((template) => template.id === defaultTaskListId)?.id;
};
